import { motion } from "framer-motion";
import { Palette, BookHeart, Recycle, Sparkles } from "lucide-react";
import { BENEFITS } from "@/data/content";
import { Reveal, SectionHeading } from "./Reveal";
import { InlineCta } from "./InlineCta";

const ICONS = { preserve: Palette, stories: BookHeart, clutter: Recycle, revisit: Sparkles };

const BenefitCard = ({ b, i }) => {
  const Icon = ICONS[b.key];
  const dark = b.tone === "bg-navy";
  return (
    <Reveal delay={i * 0.08} className={`${b.span} h-full`}>
      <motion.article
        data-testid={`benefit-card-${b.key}`}
        whileHover={{ y: -5 }}
        transition={{ type: "spring", stiffness: 260, damping: 22 }}
        className={`group relative flex h-full min-h-[300px] overflow-hidden rounded-[2rem] ${b.tone} shadow-[0_18px_50px_-30px_rgba(18,52,90,0.35)] ${b.image ? "flex-col sm:flex-row" : "flex-col"}`}
      >
        <div className="flex flex-1 flex-col justify-between p-7 sm:p-9">
          <span className={`flex h-12 w-12 items-center justify-center rounded-2xl ${dark ? "bg-teal text-white" : "bg-navy text-cream"}`}>
            <Icon className="h-5 w-5" aria-hidden="true" />
          </span>
          <div className="mt-10">
            <h3 className={`font-heading text-2xl sm:text-[1.7rem] font-extrabold leading-tight tracking-tight ${dark ? "text-cream" : "text-navy"}`}>{b.title}</h3>
            <p className={`mt-3 max-w-sm text-base leading-relaxed ${dark ? "text-cream/80" : "text-navy/75"}`}>{b.text}</p>
          </div>
        </div>
        {b.image && (
          <div className="relative h-60 sm:h-auto sm:w-[44%] overflow-hidden">
            <img src={b.image} alt="" loading="lazy" className="absolute inset-0 h-full w-full object-cover transition-transform duration-1000 ease-out group-hover:scale-105" />
          </div>
        )}
      </motion.article>
    </Reveal>
  );
};

export const Benefits = () => (
  <section id="why-keepthis" aria-labelledby="why-heading" className="relative bg-[#F4EFE4] px-5 py-24 sm:px-8 lg:py-36">
    <div className="mx-auto max-w-7xl">
      <SectionHeading id="why-heading" eyebrow="Why KeepThis!" title="Every little thing becomes a big memory." />
      <div className="mt-14 grid grid-cols-1 gap-5 md:grid-cols-3 md:auto-rows-fr lg:mt-16 lg:gap-6">
        {BENEFITS.map((b, i) => <BenefitCard key={b.key} b={b} i={i} />)}
      </div>
      <InlineCta source="benefits" text="Less clutter, more memories. Join the early-access list." />
    </div>
  </section>
);
